const icon = (props) => {
    let { className, ...remainingProps } = props

    className = className ?
        className + ' material-icons' :
        'material-icons'

    return <i className={className} {...remainingProps}>{props.children}</i>
}

export default icon